export default __webpack_public_path__ + "static/media/Logout.0cc2c930.svg";